import { render } from "./Aperture.vue?vue&type=template&id=23f71620"
import script from "./Aperture.vue?vue&type=script&lang=js"
export * from "./Aperture.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__